import { render } from "./SortableItems.vue?vue&type=template&id=7d28b205"
import script from "./SortableItems.vue?vue&type=script&lang=js"
export * from "./SortableItems.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__